<template>
    <div>
        <b-modal
            id="modal-edit"
            title="Editar Curso"
            hide-footer>
            <b-overlay :show="loading" rounded="sm">
                <b-form @submit.stop.prevent="submit">

                    <!-- Field -->
                    <b-form-group
                        label="Nome do Curso">
                        <!-- Input -->
                        <b-form-input
                            v-model="form.name"
                        ></b-form-input>
                        <!-- Error -->
                        <has-errors :errors="errors" name="name" />
                    </b-form-group>

                    <b-form-group
                        label="Descrição do Curso">
                        <!-- Input -->
                        <b-form-input
                            v-model="form.description"
                        ></b-form-input>
                        <!-- Error -->
                        <has-errors :errors="errors" name="description" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Turmas"
                        description="Quais turmas você deseja liberar esse curso ?">

                        <!-- Input -->
                        <multiselect
                            v-model="form.groups"
                            :options="groups"
                            :loading="loading"
                            track-by="id"
                            label="name"
                            placeholder=""
                            :multiple="true"
                            :taggable="true"
                            tag-placeholder="Buscar Turma"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">
                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há turmas para exibir no momento :(
                            </span>
                        </multiselect>
                        <!-- Error -->
                        <has-errors :errors="errors" name="groups" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Imagem de Capa"
                        description="Tamanho máximo de 1MB">
                        <!-- Input -->
                        <b-form-file
                            ref="file"
                            accept="image/*"
                            placeholder=""
                            browse-text="Procurar Imagem"
                            no-drop
                        ></b-form-file>
                        <!-- Error -->
                        <has-errors :errors="errors" name="img_preview" />
                    </b-form-group>

                    <!-- Submit -->
                    <b-button type="submit" variant="primary" :disable="loading">
                        Editar Curso
                    </b-button>
                </b-form>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ['groups'],
    data() {
        return {
            loading: false,
            errors: {},
            id: null,
            form: {
                name: null,
                img_preview: null,
                groups: []
            }
        }
    },
    created() {
        this.$root.$on('open-modal-edit', (course) => {
            this.id = course.id;
            this.form.name = course.name;
            this.form.groups = course.groups;
            this.$bvModal.show('modal-edit');
        })
    },
    methods: {
        submit() {
            this.loading = true;

            let formData = new FormData();

            if (this.form.name) {
                formData.append('name', this.form.name);
            }
            if (this.form.description) {
                formData.append('description', this.form.description);
            }


            this.form.groups.map(element => {
                formData.append('groups[]', element.id);
            });

            if (this.$refs.file.files[0]) {
                formData.append('img_preview', this.$refs.file.files[0]);
            }

            axios.post('/teacher/courses/' + this.id, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    // Callback
                    this.$emit('updated')

                    // Close Modal
                    this.$bvModal.hide('modal-edit')

                    // Message
                    this.$toast.success('Curso atualizado com sucesso!')

                    // Clear Form
                    this.form = {
                        name: null,
                        description: null,
                        img_preview: null,
                        groups: []
                    }

                    // Clear Errors
                    this.errors = {}
                })
                .catch(errors => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    }
}
</script>

<style scoped>

</style>
